import { render, staticRenderFns } from "./Exhibition3.vue?vue&type=template&id=605f821a&scoped=true"
import script from "./Exhibition3.vue?vue&type=script&lang=js"
export * from "./Exhibition3.vue?vue&type=script&lang=js"
import style0 from "./Exhibition3.vue?vue&type=style&index=0&id=605f821a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605f821a",
  null
  
)

export default component.exports